import React, { useState, useEffect, } from 'react';
import { Layout, Row, } from 'antd';
import { UserOutlined, ArrowLeftOutlined, ArrowRightOutlined, } from '@ant-design/icons';
import { StationSideBarItem } from './StationSideBarItem.component';
import { CustomerInformationCard } from './CustomerInformationCard.component';
import { StationList } from './StationList.component';
import Logo from '../../../../assets/AvaLAN_W.png';
import './StationSideBar.css';

const { Sider } = Layout;

export const StationSideBar = ({pendingState, setPendingChangesModal, stationListParams, setStationListParams, ...props}) => {

    const [theme, ] = useState('dark');
    const [updateAllPendingChanges, setUpdateAllPendingChanges] = useState(false);
    const [collapsed, setCollapsed] = useState(false);

    useEffect(() => {
        if(!pendingState){
            setUpdateAllPendingChanges(false);
        }
    }, [pendingState, updateAllPendingChanges])

    const sidebarTrigger = (
        <>
            <Row justify='end' align='middle' className='station__sidebar--trigger' >
                <ArrowLeftOutlined  />
            </Row>
        </>
    );

    return(
        <>
            <Sider
                className={`station__sidebar station__sidebar--${theme}-theme station__sidebar--${collapsed ? 'collapsed' : 'expanded'}`}
                trigger={null}
                collapsible 
                collapsed={collapsed} 
                onCollapse={(value) => setCollapsed(value)} 
                width={365}
                breakpoint="lg"
                theme = {theme}
                >

                <StationSideBarItem hasPadding={false} collapsed={collapsed} icon={<ArrowRightOutlined/>} tooltipText='Expand' onClick={() => {setCollapsed(!collapsed)}}>
                    {sidebarTrigger}
                </StationSideBarItem>

                <StationSideBarItem hasPadding={true} collapsed={collapsed} icon={<UserOutlined/>} tooltipWidth={300}>
                    <CustomerInformationCard />
                </StationSideBarItem>

                <StationSideBarItem hasPadding={true} collapsed={collapsed} hasTooltip={false} displayCollapsed={false}>
                    <StationList 
                        theme={theme} 
                        setPendingChangesModal={setPendingChangesModal}
                        stationListParams={stationListParams}
                        setStationListParams={setStationListParams}
                    />
                </StationSideBarItem>

                <div className='station__sidebar__logo'>
                    {/* <img src={Logo} alt="AvaLAN Networks"/> */}
                </div>
            </Sider>
        </>
    );
};